import React from "react";

const Selections = (props) => {
    const selectedDisplay = props.selections.map((opt, index) => {
        return (
            <div
                key={`selection_${index}`}
                className="selection"
                onClick={() => {
                    props.removeAfterIndex(opt, index);
                }}
            >
                {opt.description}
            </div>
        );
    });

    return (
        <header>
            <h3 onClick={props.clearTaxonomy}>Taxonomy</h3>
            <div className="selections">{selectedDisplay}</div>
        </header>
    );
};

export default React.memo(Selections, (prevProps, nextProps) => {
    return prevProps.selections === nextProps.selections;
});
